/* Lightweight updater for UA free shipping bar
  - Tracks cart total and updates progress towards free shipping thresholds
  - Reacts to carrier (UP/NP) selection to switch thresholds/labels
  - Integrates with shipping widget via window.updateBars()
*/
(function () {
  const SEL = '.ua-freebar';
  const FREE_UP = 400;
  const FREE_NP = 1500;

  if (window.UAFreebar) return;
  const state = {
    aborter: null,
    lastTotal: null,
    ticking: false,
  };

  const $all = () => Array.from(document.querySelectorAll(SEL));
  const clamp = (x, a, b) => Math.max(a, Math.min(b, x));
  const fmt = (n) => Math.max(0, Math.ceil(n)).toLocaleString('uk-UA') + ' ₴';

  function render(total) {
    const needUp = Math.max(0, FREE_UP - total);
    const needNp = Math.max(0, FREE_NP - total);

    // Статичний режим: завжди рахуємо прогрес від 0 до 1500 (НП)
    const pct = clamp((total / FREE_NP) * 100, 0, 100);

    $all().forEach(wrap => {
      // Не перемикаємо класи за перевізником
      wrap.classList.remove('ua-freebar--up', 'ua-freebar--np');

      const fill = wrap.querySelector('.ua-freebar__fill');
      if (fill) fill.style.width = pct + '%';

      const lineA = wrap.querySelector('.ua-freebar__line--active');
      const lineB = wrap.querySelector('.ua-freebar__line--both');

      // Єдина активна лінія з коротким статусом обох порогів
      if (lineA) {
        if (total < FREE_UP) {
          lineA.textContent = `Ще ${fmt(needUp)} до безкоштовної доставки Укрпоштою`;
        } else if (total < FREE_NP) {
          lineA.textContent = `Укрпошта: безкоштовно ✅ · Ще ${fmt(needNp)} до безкоштовної доставки Новою поштою`;
        } else {
          lineA.textContent = 'Укрпошта: безкоштовно ✅ · Нова пошта: безкоштовно ✅';
        }
      }

      // Друга лінія — детальний дублікат для ясності
      if (lineB) {
        lineB.textContent =
          `УП: ${needUp===0?'безкоштовно ✅':'ще ' + fmt(needUp)} · ` +
          `НП: ${needNp===0?'безкоштовно ✅':'ще ' + fmt(needNp)}`;
      }
    });
  }

  // дебаунс без накопичення викликів
  const schedule = (() => {
    let t = null;
    return (ms = 200) => {
      clearTimeout(t);
      t = setTimeout(update, ms);
    };
  })();

  async function fetchTotal() {
    try {
      if (state.aborter) state.aborter.abort();
      state.aborter = new AbortController();
      const res = await fetch('/cart.js', { credentials: 'include', signal: state.aborter.signal });
      const json = await res.json();
      return (json.total_price || 0) / 100;
    } catch (_) {
      return state.lastTotal ?? 0;
    }
  }

  async function update() {
    if (state.ticking) return;        // не дозволяємо конкурентні апдейти
    state.ticking = true;

    const total = await fetchTotal();
    state.lastTotal = total;
    render(total);

    state.ticking = false;
  }

  // Bridge for other widgets: allow calling window.updateBars() to refresh freebar
  // ua-shipping.js calls window.updateBars(root), we accept and ignore args
  window.updateBars = window.updateBars || function(){ schedule(0); };

  // Патчимо fetch один раз — ловимо всі /cart… зміни і оновлюємо після них
  (function patchFetch() {
    if (window.__uaFreebarFetchPatched) return;
    window.__uaFreebarFetchPatched = true;
    const orig = window.fetch;
    window.fetch = async function (...args) {
      const res = await orig.apply(this, args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
        if (/\/cart(\/|\.js|\/add|\/change|\/update|\/clear)/.test(url)) schedule(220);
      } catch (_) {}
      return res;
    };
  })();

  // На будь-які кліки по +/- та ручні інпути — лише плануємо один апдейт
  ['click','input','change'].forEach(evt => {
    document.addEventListener(evt, (e) => {
      const t = e.target;
      if (!t) return;
      const qtyBtn = t.matches('button[name="plus"], button[name="minus"], .quantity__button');
      const qtyInp = t.matches('input[name^="updates"]');
      if (qtyBtn || qtyInp) schedule(220);
    }, true);
  });

  // Початковий рендер
  document.addEventListener('DOMContentLoaded', () => schedule(0));

  // === Hide/restore all freebars outside the cart drawer (no CSS) ===
(function setupCartDrawerSync(){
  function setCartOpen(open){
    // показуємо bar тільки в дравері
    document.querySelectorAll('.ua-freebar').forEach(el => {
      const insideDrawer = !!el.closest('.cart-drawer__freebar');
      if (open && !insideDrawer) {
        el.dataset._uaPrevDisplay = el.style.display || '';
        el.style.display = 'none';
      } else {
        if (el.dataset._uaPrevDisplay !== undefined) {
          el.style.display = el.dataset._uaPrevDisplay;
          delete el.dataset._uaPrevDisplay;
        } else {
          el.style.display = '';
        }
      }
    });
  }

  function update(){
    const open = !!document.querySelector('.cart-drawer__body');
    setCartOpen(open);
    // Width/layout fixes handled via theme CSS; no JS overrides here
  }

  // спостерігаємо за DOM, щоб ловити відкриття/закриття дравера
  const mo = new MutationObserver(() => setTimeout(update, 0));
  mo.observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['class','style','aria-hidden','open']});

  // клік по кнопці відкриття
  document.addEventListener('click', e => {
    if (e.target.closest('[data-sidebar-button][data-sidebar-id="CartDrawer"]')) {
      setTimeout(update, 50);
    }
  });

  // Initial run
  update();

  // Public API (backward-compatible no-op fixDrawerWidth)
  const fixDrawerWidth = () => {};
  window.UAFreebar = Object.assign(window.UAFreebar || {}, { setCartOpen: setCartOpen, fixDrawerWidth });
})();

  // Carrier switches більше не впливають на freebar; залишаємо лише загальний рескан за кліками карт
  document.addEventListener('click', e => { if (e.target.closest('.ua-card')) schedule(0); }, true);


  // Публічний API (про всяк випадок)
  window.UAFreebar = { update: () => schedule(0) };
})();
